import { Calendar } from 'lucide-react';
import { E2E_USER_HOME } from '@/constants/e2eSchedulingTestIds';
import { cn } from '@/lib/utils';
import { UserHomeCard, UserHomeCardHeader } from './UserHomeCard';
import {
	userHomeDividerClassName,
	userHomePrimaryButtonClassName,
} from './userHomeCardStyles';

const BULLETS = [
	'Conecte-se individualmente com um profissional certificado',
	'Conheça o perfil e a abordagem de cada especialista',
	'Escolha o horário que funciona melhor para você',
];

type UserHomeScheduleBannerProps = {
	onSchedule: () => void;
	className?: string;
};

const UserHomeScheduleBanner = ({
	onSchedule,
	className,
}: UserHomeScheduleBannerProps) => {
	return (
		<UserHomeCard className={className}>
			<UserHomeCardHeader
				icon={<Calendar size={22} />}
				label="Agendar"
				title="Faça uma consulta online"
				description="Marque sua sessão em poucos passos, no horário que preferir"
			/>

			<div className={cn(userHomeDividerClassName, 'space-y-4')}>
				<ul className="space-y-2" role="list">
					{BULLETS.map((item) => (
						<li
							key={item}
							className="flex items-start gap-2.5 text-sm leading-snug text-zinc-600 md:text-[15px]"
						>
							<span
								className="mt-1.5 block h-1.5 w-1.5 shrink-0 rounded-full bg-zinc-800"
								aria-hidden
							/>
							{item}
						</li>
					))}
				</ul>

				<button
					type="button"
					data-testid={E2E_USER_HOME.SCHEDULE_BUTTON}
					data-site-tutorial="home-schedule-button"
					onClick={onSchedule}
					className={userHomePrimaryButtonClassName}
				>
					Agendar agora
				</button>
			</div>
		</UserHomeCard>
	);
};

export { UserHomeScheduleBanner };
